import {signal} from '@preact/signals-react';

export const projectNameSignal = signal<string | null>(null);
